// libs
import React, { createContext, useReducer } from "react";

// defs
import { IAllocationType } from "@defs/Utilities";
import { UserSandboxAccess } from "@utils/appsync/schema/API";
import { initialUserInfoState, IUserInfoState } from "@store/state/UserInfo";

// stores
import {
    setSelectedAllocationType,
    setEmail,
    setIsUserAuthorized,
    setSandboxes,
    setSelectedSandbox,
    setUserInfo,
    setUsername,
    setFeatureFlags,
} from "@store/actions/UserInfo";
import { userInfoReducer } from "@store/reducer/UserInfo";

export interface IUserInfoContext extends IUserInfoState {
    setEmail: (email: string) => void;
    setUsername: (username: string) => void;
    setIsUserAuthorized: (isAuthorized: boolean) => void;
    setSelectedSandbox: (sandbox: UserSandboxAccess) => void;
    setSandboxes: (sandboxes: Array<UserSandboxAccess>) => void;
    setAllocationType: (allocationType: IAllocationType) => void;
    setUserInfo: (userInfo: Partial<IUserInfoState>) => void;
    setFeatureFlags: (featureFlags: object) => void;
}

export const UserInfoContext = createContext<IUserInfoContext | undefined>(undefined);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const UserInfoProvider = ({ children }) => {
    const [state, dispatch] = useReducer(userInfoReducer, initialUserInfoState);

    return (
        <UserInfoContext.Provider
            value={{
                ...state,
                setEmail: setEmail(dispatch),
                setUsername: setUsername(dispatch),
                setIsUserAuthorized: setIsUserAuthorized(dispatch),
                setSelectedSandbox: setSelectedSandbox(dispatch),
                setSandboxes: setSandboxes(dispatch),
                setAllocationType: setSelectedAllocationType(dispatch),
                setUserInfo: setUserInfo(dispatch),
                setFeatureFlags: setFeatureFlags(dispatch),
            }}>
            {children}
        </UserInfoContext.Provider>
    );
};
